import DashboardService from '../services/services';
import AccountModel from './accountModel';
import ProfileModel from './profileModel';
import AddressModel from './addressModel';
import StoreModel from './storeModel';

class DashboardModel extends AccountModel{
    constructor(ProfileModel, AddressModel, StoreModel) {
        super();
        this.relationships = {
            profile : ProfileModel,
            address : AddressModel,
            stores : StoreModel
        }
        this.rrItems = []
        this.initialized = {}
    }

    /**
     * Method to collect and display Recently Viewed products
     * First check if the global var for Rich Relevance (RR) is defined;
     * If so, save items to the rrItems model property
     * If not, run an interval to retry check
    */
    getRR() {
        let setRRdata;

        if ( (typeof RR != "undefined") && (typeof RR.data != "undefined") ) {
            let rrItems = RR.data.JSON.placements[0];

            return Promise.resolve(super.setData(rrItems, 'rrItems', true));
        }
        else {
            return new Promise((resolve,reject)=>{
                setRRdata = () => {
                    let rrItems;
                    if ( (typeof RR != "undefined") && (typeof RR.data != "undefined") ) {
                        rrItems = RR.data.JSON.placements[0];
                        clearInterval(rrInterval);
                        resolve(super.setData(rrItems, 'rrItems', true));
                    }
                }

                let rrInterval = window.setInterval(setRRdata, 100);
            })
        }
    }
}

let Dashboard = new DashboardModel(ProfileModel, AddressModel, StoreModel);

export default Dashboard;
